import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { autoJudgeBasisConfig } from './AutoJudgeBasis.name';

/** 自動判定基準のENUM */
enum AutoJudgeBasis {
  /** リース会計基準 */
  leaseAccountBasis = '1',
  /** 税務基準 */
  taxBasis = '2',
  /** IFRS基準 */
  ifrsBasis = '3',
}

const autoJudgeBasisMap = new Map([
  ['1', AutoJudgeBasis.leaseAccountBasis],
  ['2', AutoJudgeBasis.taxBasis],
  ['3', AutoJudgeBasis.ifrsBasis],
]);

const rawValueToAutoJudgeBasis = rawValueToEnumWithDefault(
  autoJudgeBasisMap,
  AutoJudgeBasis.leaseAccountBasis,
);

const autoJudgeBasisToDisplay = enumToNameWithDefault(AutoJudgeBasis, autoJudgeBasisConfig);

const autoJudgeBasisToDisplayWithPrefix = enumToNameWithDefault(AutoJudgeBasis, autoJudgeBasisConfig, true);

export {
  AutoJudgeBasis,
  autoJudgeBasisToDisplay,
  autoJudgeBasisToDisplayWithPrefix,
  rawValueToAutoJudgeBasis,
};
